import { apiCall } from './gqlClient';

const USEREXERCISELOGS_QUERY = `
  query userExerciseLogs($userWorkoutProgressId: String!) {
    userExerciseLogs(userWorkoutProgressId: $userWorkoutProgressId)
    {
      id
			userWorkoutProgressId
			exerciseId
			circuitExerciseId
			setsCompleted
			repsCompleted
			weightUsed
			rirAchieved
			athleteNote
			coachFeedback
			dateCreated
      ...fragments
    }
  }`;

export const userExerciseLogsApiCall = async ({userWorkoutProgressId}, fragments = null) => apiCall({ query: USEREXERCISELOGS_QUERY, variables: {userWorkoutProgressId}, fragments });

const CREATEUSEREXERCISELOG_QUERY = `
  mutation createUserExerciseLog($input: UserExerciseLogInput!) {
    createUserExerciseLog(input: $input)
    {
      id
			userWorkoutProgressId
			exerciseId
			circuitExerciseId
			setsCompleted
			repsCompleted
			weightUsed
			rirAchieved
			athleteNote
			coachFeedback
			dateCreated
      ...fragments
    }
  }`;

export const createUserExerciseLogApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEUSEREXERCISELOG_QUERY, variables: {input}, fragments });

const UPDATEUSEREXERCISELOG_QUERY = `
  mutation updateUserExerciseLog($id: String!, $input: UserExerciseLogUpdateInput!) {
    updateUserExerciseLog(id: $id, input: $input)
    {
      id
			userWorkoutProgressId
			exerciseId
			circuitExerciseId
			setsCompleted
			repsCompleted
			weightUsed
			rirAchieved
			athleteNote
			coachFeedback
			dateCreated
      ...fragments
    }
  }`;

export const updateUserExerciseLogApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEUSEREXERCISELOG_QUERY, variables: {id, input}, fragments });

const DELETEUSEREXERCISELOG_QUERY = `
  mutation deleteUserExerciseLog($id: String!) {
    deleteUserExerciseLog(id: $id)
    {
      id
			userWorkoutProgressId
			exerciseId
			circuitExerciseId
			setsCompleted
			repsCompleted
			weightUsed
			rirAchieved
			athleteNote
			coachFeedback
			dateCreated
      ...fragments
    }
  }`;

export const deleteUserExerciseLogApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEUSEREXERCISELOG_QUERY, variables: {id}, fragments });
